import {
  GET_PO_LISTING_REQUEST,
  GET_PO_LISTING_SUCCESS,
  GET_PO_LISTING_FAILURE,
  GET_PO_PROCESS_LOG_REQUEST,
  GET_PO_PROCESS_LOG_SUCCESS,
  GET_PO_PROCESS_LOG_FAILURE,
  GET_ROUTING_INFO_BY_PO_REQUEST,
  GET_ROUTING_INFO_BY_PO_SUCCESS,
  GET_ROUTING_INFO_BY_PO_FAILURE,
  GET_OPERATIONS_LIST_BY_PO_REQUEST,
  GET_OPERATIONS_LIST_BY_PO_SUCCESS,
  GET_OPERATIONS_LIST_BY_PO_FAILURE,
  PUT_RELEASE_PO_REQUEST,
  PUT_RELEASE_PO_SUCCESS,
  PUT_RELEASE_PO_FAILURE,
  GET_PO_PROCESS_LOG_REPORTS_SUCCESS,
  GET_PO_PROCESS_LOG_REPORTS_REQUEST,
  GET_PO_PROCESS_LOG_REPORTS_FAILURE,
  UPDATE_SUB_CONTRACTING_REQUEST,
  UPDATE_SUB_CONTRACTING_SUCCESS,
  UPDATE_SUB_CONTRACTING_FAILURE,
  UPDATE_DEPENDENCY_REQUEST,
  UPDATE_DEPENDENCY_SUCCESS,
  UPDATE_DEPENDENCY_FAILURE,
  UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_REQUEST,
  UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_SUCCESS,
  UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_FAILURE,
  GET_PO_LISTING_WITHOUT_PAGINATION_REQUEST,
  GET_PO_LISTING_WITHOUT_PAGINATION_FAILURE,
  GET_PO_LISTING_WITHOUT_PAGINATION_SUCCESS,
  UPLOADCSV_FOR_PO_LISTING_REQUEST,
  UPLOADCSV_FOR_PO_LISTING_FAILURE,
  UPLOADCSV_FOR_PO_LISTING_SUCCESS,
  GET_COMPLETED_PO_LISTING_REQUEST,
  GET_COMPLETED_PO_LISTING_SUCCESS,
  GET_COMPLETED_PO_LISTING_FAILURE,
  POST_REPORT_TO_ERP_REQUEST,
  POST_REPORT_TO_ERP_SUCCESS,
  POST_REPORT_TO_ERP_FAILURE,
  GET_CONSUMED_SUIDS_REQUEST,
  GET_CONSUMED_SUIDS_SUCCESS,
  GET_CONSUMED_SUIDS_FAILURE,
} from "./poManagementTypes";
import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;

const getPoListingRequest = () => {
  return {
    type: GET_PO_LISTING_REQUEST,
  };
};

const getPoListingSuccess = (payload) => {
  return {
    type: GET_PO_LISTING_SUCCESS,
    payload: payload,
  };
};

const getPoListingFailure = (error) => {
  return {
    type: GET_PO_LISTING_FAILURE,
    payload: error,
  };
};

const getPoListing = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPoListingRequest());
    let url = `${baseUrl}/po_dashboard?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPoListingSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPoListingFailure(err.message));
      });
  };
};

const getRoutingInfoByPORequest = () => {
  return {
    type: GET_ROUTING_INFO_BY_PO_REQUEST,
  };
};

const getRoutingInfoByPOSuccess = (payload) => {
  return {
    type: GET_ROUTING_INFO_BY_PO_SUCCESS,
    payload: payload,
  };
};

const getRoutingInfoByPOFailure = (error) => {
  return {
    type: GET_ROUTING_INFO_BY_PO_FAILURE,
    payload: error,
  };
};

const getRoutingInfoByPO = (poNumber, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getRoutingInfoByPORequest());
    let url = `${baseUrl}/view_porouting_dashboard?poId=${poNumber}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getRoutingInfoByPOSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRoutingInfoByPOFailure(err.message));
      });
  };
};

const releasePoRequest = () => {
  return {
    type: PUT_RELEASE_PO_REQUEST,
  };
};

const releasePoSuccess = (payload) => {
  return {
    type: PUT_RELEASE_PO_SUCCESS,
    payload: payload,
  };
};

const releasePoFailure = (error) => {
  return {
    type: PUT_RELEASE_PO_FAILURE,
    payload: error,
  };
};

const releasePo = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(releasePoRequest());
    let url = `${baseUrl}/po_release_dashboard`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(releasePoSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(releasePoFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getPoProcessLogRequest = () => {
  return {
    type: GET_PO_PROCESS_LOG_REQUEST,
  };
};

const getPoProcessLogSuccess = (payload) => {
  return {
    type: GET_PO_PROCESS_LOG_SUCCESS,
    payload: payload,
  };
};

const getPoProcessLogFailure = (error) => {
  return {
    type: GET_PO_PROCESS_LOG_FAILURE,
    payload: error,
  };
};

const getPoProcessLog = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPoProcessLogRequest());
    let url = `${baseUrl}/poprocesslog?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPoProcessLogSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPoProcessLogFailure(err.message));
      });
  };
};

const getPoProcessLogReportsRequest = () => {
  return {
    type: GET_PO_PROCESS_LOG_REPORTS_REQUEST,
  };
};

const getPoProcessLogReportsSuccess = (payload) => {
  return {
    type: GET_PO_PROCESS_LOG_REPORTS_SUCCESS,
    payload: payload,
  };
};

const getPoProcessLogReportsFailure = (error) => {
  return {
    type: GET_PO_PROCESS_LOG_REPORTS_FAILURE,
    payload: error,
  };
};

const getPoProcessLogReports = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPoProcessLogReportsRequest());
    let url = `${baseUrl}/po_process_log/report`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPoProcessLogReportsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPoProcessLogReportsFailure(err.message));
      });
  };
};

const updateSubContractingStatusRequest = () => {
  return {
    type: UPDATE_SUB_CONTRACTING_REQUEST,
  };
};

const updateSubContractingStatusSuccess = (payload) => {
  return {
    type: UPDATE_SUB_CONTRACTING_SUCCESS,
    payload: payload,
  };
};

const updateSubContractingStatusFailure = (error) => {
  return {
    type: UPDATE_SUB_CONTRACTING_FAILURE,
    payload: error,
  };
};

const updateSubContractingStatus = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateSubContractingStatusRequest());
    let url = `${baseUrl}/po/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateSubContractingStatusSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateSubContractingStatusFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getOperationsListByPORequest = () => {
  return {
    type: GET_OPERATIONS_LIST_BY_PO_REQUEST,
  };
};

const getOperationsListByPOSuccess = (payload) => {
  return {
    type: GET_OPERATIONS_LIST_BY_PO_SUCCESS,
    payload: payload,
  };
};

const getOperationsListByPOFailure = (error) => {
  return {
    type: GET_OPERATIONS_LIST_BY_PO_FAILURE,
    payload: error,
  };
};

const getOperationsListByPO = (poNumber, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getOperationsListByPORequest());
    let url = `${baseUrl}/po_routing/get_operation_list?poId=${poNumber}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getOperationsListByPOSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getOperationsListByPOFailure(err.message));
      });
  };
};

const updateDependencyStageRequest = () => {
  return {
    type: UPDATE_DEPENDENCY_REQUEST,
  };
};

const updateDependencyStageSuccess = (payload) => {
  return {
    type: UPDATE_DEPENDENCY_SUCCESS,
    payload: payload,
  };
};

const updateDependencyStageFailure = (error) => {
  return {
    type: UPDATE_DEPENDENCY_FAILURE,
    payload: error,
  };
};

const updateDependencyStage = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateDependencyStageRequest());
    let url = `${baseUrl}/po_routing/update_dependency_stage`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateDependencyStageSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateDependencyStageFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateSubContractingStatusForPoRoutingRequest = () => {
  return {
    type: UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_REQUEST,
  };
};

const updateSubContractingStatusForPoRoutingSuccess = (payload) => {
  return {
    type: UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_SUCCESS,
    payload: payload,
  };
};

const updateSubContractingStatusForPoRoutingFailure = (error) => {
  return {
    type: UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_FAILURE,
    payload: error,
  };
};

const updateSubContractingStatusForPoRouting = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateSubContractingStatusForPoRoutingRequest());
    let url = `${baseUrl}/po_routing/update_sub_contract`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateSubContractingStatusForPoRoutingSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateSubContractingStatusForPoRoutingFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getPoListingWithoutPaginationRequest = () => {
  return {
    type: GET_PO_LISTING_WITHOUT_PAGINATION_REQUEST,
  };
};

const getPoListingWithoutPaginationSuccess = (payload) => {
  return {
    type: GET_PO_LISTING_WITHOUT_PAGINATION_SUCCESS,
    payload: payload,
  };
};

const getPoListingWithoutPaginationFailure = (error) => {
  return {
    type: GET_PO_LISTING_WITHOUT_PAGINATION_FAILURE,
    payload: error,
  };
};

const getPoListingWithoutPagination = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPoListingWithoutPaginationRequest());
    let url = `${baseUrl}/po/get_for_bom`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPoListingWithoutPaginationSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPoListingWithoutPaginationFailure(err.message));
      });
  };
};

const uploadCsvForPoListingRequest = () => {
  return {
    type: UPLOADCSV_FOR_PO_LISTING_REQUEST,
  };
};

const uploadCsvForPoListingSuccess = (payload) => {
  return {
    type: UPLOADCSV_FOR_PO_LISTING_SUCCESS,
    payload: payload,
  };
};

const uploadCsvForPoListingFailure = (error) => {
  return {
    type: UPLOADCSV_FOR_PO_LISTING_FAILURE,
    payload: error,
  };
};

const uploadCsvForPoListing = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadCsvForPoListingRequest());
    let url = `${baseUrl}/po/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForPoListingSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForPoListingFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getCompletedPoListingRequest = () => {
  return {
    type: GET_COMPLETED_PO_LISTING_REQUEST,
  };
};

const getCompletedPoListingSuccess = (payload) => {
  return {
    type: GET_COMPLETED_PO_LISTING_SUCCESS,
    payload: payload,
  };
};

const getCompletedPoListingFailure = (error) => {
  return {
    type: GET_COMPLETED_PO_LISTING_FAILURE,
    payload: error,
  };
};

const getCompletedPoListing = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getCompletedPoListingRequest());
    let url = `${baseUrl}/po/completed?page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getCompletedPoListingSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getCompletedPoListingFailure(err.message));
      });
  };
};

const reportToERPRequest = () => {
  return {
    type: POST_REPORT_TO_ERP_REQUEST,
  };
};

const reportToERPSuccess = (payload) => {
  return {
    type: POST_REPORT_TO_ERP_SUCCESS,
    payload: payload,
  };
};

const reportToERPFailure = (error) => {
  return {
    type: POST_REPORT_TO_ERP_FAILURE,
    payload: error,
  };
};

const reportToERP = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(reportToERPRequest());
    let url = `${baseUrl}/po/report_to_erp`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(reportToERPSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(reportToERPFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getConsumedSuidsRequest = () => {
  return {
    type: GET_CONSUMED_SUIDS_REQUEST,
  };
};

const getConsumedSuidsSuccess = (payload) => {
  return {
    type: GET_CONSUMED_SUIDS_SUCCESS,
    payload: payload,
  };
};

const getConsumedSuidsFailure = (error) => {
  return {
    type: GET_CONSUMED_SUIDS_FAILURE,
    payload: error,
  };
};

const getConsumedSuids = (
  poId,
  operationId,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getConsumedSuidsRequest());
    let url = `${baseUrl}/po/get_consumed_suids?poId=${poId}&operationId=${operationId}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&download=0`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getConsumedSuidsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getConsumedSuidsFailure(err.message));
      });
  };
};

export {
  getPoListing,
  getPoProcessLog,
  getRoutingInfoByPO,
  getOperationsListByPO,
  releasePo,
  getPoProcessLogReports,
  updateSubContractingStatus,
  updateDependencyStage,
  updateSubContractingStatusForPoRouting,
  getPoListingWithoutPagination,
  uploadCsvForPoListing,
  getCompletedPoListing,
  reportToERP,
  getConsumedSuids,
};
